module.exports = __webpack_public_path__ + "img/safe.bcedf50.svg";